import * as yup from 'yup';
import { isSecondCar } from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';

export const erstfahrzeugContractSchema = yup.object({
  kennzeichen: yup
    .string()
    .default('')
    .when({
      is: () => isSecondCar(),
      then: yup.string().required(),
    }),
  versicherungsscheinnummer: yup
    .string()
    .max(17)
    .default('')
    .when({
      is: () => isSecondCar(),
      then: yup.string().required(),
    }),
});
